import React from 'react';

interface ExportOptionsModalProps {
  selectedCount: number;
  onExport: (includePhone: boolean) => void;
  onClose: () => void;
}

export const ExportOptionsModal: React.FC<ExportOptionsModalProps> = ({
  selectedCount,
  onExport,
  onClose,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full mx-4">
        <div className="p-6">
          <h3 className="text-lg font-semibold text-wedding-text-title mb-4">匯出郵寄選項</h3>

          <div className="space-y-4">
            <div className="text-sm text-wedding-text-body">
              將匯出 <span className="font-semibold text-wedding-pink">{selectedCount}</span> 筆實體喜帖資料
            </div>

            <div className="space-y-2">
              <label className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  id="includePhone"
                  defaultChecked={true}
                  className="rounded border-gray-300 text-wedding-pink focus:ring-wedding-pink"
                />
                <span className="text-sm text-wedding-text-title">包含聯絡電話</span>
              </label>
              <p className="text-xs text-wedding-text-body ml-6">
                將從 RSVP 資料中獲取賓客的聯絡電話號碼
              </p>
            </div>
          </div>

          <div className="flex space-x-3 mt-6">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
            >
              取消
            </button>
            <button
              onClick={() => {
                const includePhone = (document.getElementById('includePhone') as HTMLInputElement)?.checked;
                onExport(includePhone);
                onClose();
              }}
              className="flex-1 px-4 py-2 bg-wedding-pink text-white rounded-md hover:bg-wedding-pink/90"
            >
              匯出
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
